import barba from "@barba/core";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Splide from "@splidejs/splide";

gsap.registerPlugin(ScrollTrigger);


export default class {
    triggers = [];
    constructor() {
        this.run(document);
        this.intro_animation();
        
    }
    
    run(d) {
        /* --------------------------------
              KV Slider
        -------------------------------- */
        const topKv = d.querySelector("[data-kv-slider]");
        if(topKv) {
            const splide = new Splide("[data-kv-slider]",{
                autoplay: true,
                type: "fade",
                rewind: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                interval: 5000,
                speed: 3000,
                pagination: false,
                drag: false,
                arrows: false,
            }).mount();
        }


        /* --------------------------------
              Service Animation
        -------------------------------- */
        const topService = document.querySelector("[data-top-service]");
        if(topService) {
            // Title Section
            const topIntro = document.querySelector("[data-top-service-intro]");
            const title = document.querySelector("[data-top-service-title]");
            gsap.set(title, {
                opacity: 0
            });
            const titleAnime = gsap.timeline({
                scrollTrigger: {
                    trigger: topIntro,
                    start: "top top",
                    end: "+=100%",     
                    scrub: true,      
                    pin: true,    
                    anticipatePin: 1,
                    // markers: true,
                    // pinSpacing: false,
                }
            });

            titleAnime.fromTo(title, 
                { opacity: 0, y: 20 },
                { 
                    opacity: 1, 
                    y: 0, 
                    stagger: 0.1,     
                    duration: 0.3 // 全体の30%の距離で表示完了
                }
            )
            .to(title, 
                { 
                    opacity: 0, 
                    duration: 0.3  // 全体の最後の30%の距離で消える
                }, 
                "+=0.4"                
            );


            // スライドのピン留めとアニメーション
            const container = document.querySelector("[data-top-service-slider]");
            const slides = document.querySelectorAll("[data-top-service-slide]");
            const slideCount = slides.length;
            const slotCount = slideCount + 1; // bgimage表示用の空きスロットを1つ追加

            gsap.set(container, {
                opacity: 0,
                scale: 0.95,
                width: slotCount * 100 + "%"
            });

            gsap.set(slides, {
                width: 100 / slotCount + "%",
            });

            // メインのタイムライン（スクロール連動）
            const serviceTl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top top",
                    end: () => "+=" + (container.offsetWidth - window.innerWidth + window.innerHeight * 2),
                    pin: true,
                    scrub: 1,
                    anticipatePin: 1,
                }
            });

            // コンテナのフェードイン＆スケールアップ
            serviceTl.to(container, {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: "power2.out"
            });

            // 横スクロールアニメーション（全体の基準となる時間：durationを3にする）
            const scrollDuration = 3;
            serviceTl.to(slides, {
                xPercent: -100 * (slotCount - 1),
                ease: "none",
                duration: scrollDuration
            }, ">");


            slides.forEach((slide, index) => {
                const startTime = 0.5 + (scrollDuration / (slotCount - 1)) * index;
                const animDuration = 0.6; 

                serviceTl.to(slide, {
                    opacity: 0,
                    scale: 0.8,
                    ease: "power1.inOut",
                    duration: animDuration
                }, startTime);

                // 画像（figure）の不透明度も同じタイミングで配置
                const figure = slide.querySelector(".top-service__slide-figure");
                if (figure) {
                    serviceTl.to(figure, {
                        opacity: 0,
                        ease: "power1.inOut",
                        duration: animDuration
                    }, startTime);
                };
            });


            // 背景画像アニメーション
            const bgImage = document.querySelector("[data-top-service-bgimage]");
            const bgImageImg = bgImage.querySelector("img");
            const lastSlideEnterStart = 0.5 + scrollDuration * ((slotCount - 2) / (slotCount - 1));
            const lastSlideEnterEnd   = 0.5 + scrollDuration;
            const enterDuration = lastSlideEnterEnd - lastSlideEnterStart;

            serviceTl.fromTo(bgImage,
                { opacity: 0 },
                { opacity: 1, ease: "none", duration: enterDuration },
                lastSlideEnterStart
            );
            serviceTl.fromTo(bgImageImg,
                { "--mask-y": 0, "--mask-size": 200 },
                { "--mask-y": 100, "--mask-size": 500, ease: "none", duration: enterDuration },
                lastSlideEnterStart
            );

            const mainDuration = lastSlideEnterEnd; 
            const baseScrollPx = container.offsetWidth - window.innerWidth;
            const holdDuration    = mainDuration * (window.innerHeight / baseScrollPx); // opacity 1 を保持する区間
            const reverseDuration = mainDuration * (window.innerHeight / baseScrollPx); // 元に戻す区間
            const reverseStart    = mainDuration + holdDuration;

            serviceTl.fromTo(bgImage,
                { opacity: 1 },
                { opacity: 0, ease: "none", duration: reverseDuration },
                reverseStart
            );
            serviceTl.fromTo(bgImageImg,
                { "--mask-y": 100, "--mask-size": 500 },
                { "--mask-y": 0, "--mask-size": 200, ease: "none", duration: reverseDuration },
                reverseStart
            );
        }
    }
    intro_animation(){
        
    }
}
